export default __webpack_public_path__ + "static/media/btp-1-rMAX.941c3fac.avif";